var modules_2fd5ce57 = {"arrows":"Arrows_module_arrows__37964828","important":"Arrows_module_important__37964828","button":"Arrows_module_button__37964828","icon":"Arrows_module_icon__37964828"};
import "../../../assets/esm/components/Carousel/src/Arrows~rqmhej-G.css";

export { modules_2fd5ce57 as default };
//# sourceMappingURL=Arrows.module.less.js.map
